// Shared constants
export const CONDITIONS = [
  "Near Mint",
  "Lightly Played",
  "Moderately Played",
  "Heavily Played",
  "Damaged",
];

// Supported PSA grades (1-10)
export const PSA_GRADES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

/*
 * Graded (PSA) prices are switched off for the public launch.
 *
 * They come from the one metered source — a hundred credits a day, shared by
 * every visitor. That was plenty for one person and is nothing for the
 * public: the allowance would be gone before lunch, and everyone after that
 * would see "out of credits until 00:00 UTC" on a feature the app had just
 * offered them. A feature that works for the first hundred lookups of the day
 * is worse than one that is not there.
 *
 * Everything underneath stays — the route, the parsing, the slab toggle's
 * code — so turning it back on is this one line, once there is a plan that
 * can carry it.
 */
export const GRADED_ENABLED = false;

// Oversize (jumbo) promos don't fit a binder and clutter results when you want
// the normal print. The API files every one of them under a single set, so this
// is an exact match rather than a guess at the card's name.
export const OVERSIZE_SET_NAME = "Jumbo Cards";
export const isOversizeCard = (card) => card?.setName === OVERSIZE_SET_NAME;

